import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormErrorScrollingService } from 'src/app/shared/form-error-scrolling/form-error-scrolling.service';
import { FormTemplateInputFormGroup } from './../form-template-input-form-group';
import { formTemplateGenericSort, FormTemplateSchema } from './../form-template-model';
import { FormTemplateAttachmentsFieldService } from './form-template-field-generator/form-template-attachment-field-generator/form-template-attachments-field.service';
import { FormTemplateGeneratorService } from './form-template-generator.service';

@Component({
  selector: 'csi-form-template-generator',
  templateUrl: './form-template-generator.component.html',
  styleUrls: ['./form-template-generator.component.scss'],
  providers: [FormTemplateAttachmentsFieldService]
})
export class FormTemplateGeneratorComponent implements OnInit {
  @Input() formTemplateSchema: FormTemplateSchema;
  @Input() readOnly: boolean = false;
  @Input() formatForPDF: boolean = false;
  @Input() isPatientView: boolean = false;
  @Input()
  set formTemplateInputFormGroup(value: FormTemplateInputFormGroup) {
    this._formTemplateInputFormGroup = value;
    this.formTemplateAttachmentsFieldService.linkAllAttachmentsToCentralizedControl(
      this.formTemplateInputFormGroup.attachments
    );
  }

  private _formTemplateInputFormGroup: FormTemplateInputFormGroup;

  public country;
  sortFormGroups = formTemplateGenericSort;

  // FOR TESTING ONLY
  private USE_SAMPLE_DATA = false;
  private sampleData = {};
  // ----------------------------------------------------------

  constructor(
    public formTemplateGeneratorService: FormTemplateGeneratorService,
    public formTemplateAttachmentsFieldService: FormTemplateAttachmentsFieldService,
    private route: ActivatedRoute,
    private hostElementRef: ElementRef,
    private formErrorScrollingService: FormErrorScrollingService
  ) {}

  get formTemplateInputFormGroup(): FormTemplateInputFormGroup {
    return this._formTemplateInputFormGroup;
  }

  next(key: string) {
    this.formTemplateInputFormGroup.controls[key].markAllAsTouched();
    if (!this.formTemplateInputFormGroup.controls[key].valid) {
      this.formErrorScrollingService.scrollToFirstInvalidControlInView(this.hostElementRef, true, {
        isHostScrollable: true,
        isHostMatStep: true
      });

      return;
    }
  }
  ngOnInit() {
    this.formTemplateAttachmentsFieldService.linkAllAttachmentsToCentralizedControl(
      this.formTemplateInputFormGroup.attachments
    );

    this.country = this.route.snapshot.queryParams['country'] || null;
    this.formTemplateGeneratorService.fieldsHiddenForPDFExportMap = {};
    if (this.readOnly || this.formatForPDF) {
      this.formTemplateInputFormGroup.disable();
    }

    setTimeout(() => {
      if (this.USE_SAMPLE_DATA) {
        this.formTemplateInputFormGroup.patchValue(this.sampleData);
      }
    }, 500);
  }
}
